module.exports = __webpack_public_path__ + "img/close.48a7feb5.png";